/*
  SD clear cart (2026-10-11)

  Adds a "Clear cart" button to the cart drawer title row and to the cart page header. The first tap arms it
  ("Tap again to clear"), the second empties the cart with /cart/clear.js. The drawer then re-renders through the
  theme's own cart:refresh event; the cart page reloads. Loaded once from snippets/sd-cart-ladder.liquid; the drawer
  is re-rendered on every cart change, so a MutationObserver puts the button back whenever it goes missing.
*/
(() => {
  if (window.sdCartClear) return;
  window.sdCartClear = true;

  const LABEL = 'Clear cart';
  const ARMED = 'Tap again to clear';
  const ARM_MS = 3500;

  const style = document.createElement('style');
  style.textContent =
    '.sd-clear{display:inline-flex;align-items:center;gap:.35rem;margin-inline-end:.75rem;padding:.3rem .7rem;' +
    'border:1px solid rgb(var(--text-color, var(--text-primary)) / .22);border-radius:999px;background:transparent;' +
    'color:rgb(var(--text-color, var(--text-primary)) / .75);font-size:var(--text-xs, .75rem);line-height:1.2;' +
    'white-space:nowrap;cursor:pointer;transition:color .15s ease,border-color .15s ease,background .15s ease}' +
    '.sd-clear:hover{color:rgb(var(--text-color, var(--text-primary)));border-color:rgb(var(--text-color, var(--text-primary)) / .5)}' +
    '.sd-clear.is-armed{color:#fff;background:#c0392b;border-color:#c0392b}' +
    '.sd-clear[disabled]{opacity:.5;cursor:wait}' +
    '.cart-header .sd-clear{margin-block-start:.75rem}';
  document.head.appendChild(style);

  const icon =
    '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6"/></svg>';

  const makeButton = () => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'sd-clear';
    button.setAttribute('data-sd-clear', '');
    button.innerHTML = `${icon}<span aria-live="polite">${LABEL}</span>`;
    return button;
  };

  const mount = () => {
    // Drawer: the title row holds the title group and the close button; the button goes just before the close button
    document.querySelectorAll('.cart-drawer__top > .h-stack').forEach((row) => {
      if (row.querySelector('[data-sd-clear]')) return;
      const close = row.querySelector('.drawer__close-icon');
      row.insertBefore(makeButton(), close || null);
    });
    // Cart page
    document.querySelectorAll('.cart-header').forEach((header) => {
      if (header.querySelector('[data-sd-clear]')) return;
      const title = header.querySelector('h1');
      if (title) title.insertAdjacentElement('afterend', makeButton());
    });
  };

  let queued = false;
  const queueMount = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      mount();
    });
  };

  const disarm = (button) => {
    clearTimeout(button._sdTimer);
    button.classList.remove('is-armed');
    button.lastElementChild.textContent = LABEL;
  };

  const clearCart = async (button) => {
    button.disabled = true;
    try {
      await fetch(`${window.Shopify?.routes?.root || '/'}cart/clear.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      });
    } catch (error) {
      /* the refresh below shows whatever the server has */
    }
    if (window.themeVariables?.settings?.pageType === 'cart' || window.location.pathname.endsWith('/cart')) {
      window.location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-sd-clear]');
    if (!button || button.disabled) return;
    event.preventDefault();
    if (!button.classList.contains('is-armed')) {
      button.classList.add('is-armed');
      button.lastElementChild.textContent = ARMED;
      button._sdTimer = setTimeout(() => disarm(button), ARM_MS);
      return;
    }
    disarm(button);
    clearCart(button);
  });

  new MutationObserver(queueMount).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
})();
